import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { ModalProvider } from './Components/Modal/ModalContext';
import { TimeModalProvider } from './Components/TimeModal/TimeModalContext';

import Index from './Pages/Index';
import Account from './Pages/Account';
import Users from './Pages/Users';
import Fields from './Pages/Fields'
import SiteMainImages from './Pages/SiteMainImages';
import NotFound from './Pages/NotFound';

import Login from './Pages/Login';
import Registration from './Pages/Registration';
import Logout from './Components/Logout';

import PrivateRoute from './Components/PrivateRoute';
import PublicRoute from './Components/PublicRoute';
import RouteTitleUpdater from './Components/RouteTitleUpdater';

function App() {
  const location = useLocation();

  return (
    <ModalProvider>
      <TimeModalProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
          <Route path="/site-main-images" element={<PrivateRoute><SiteMainImages /></PrivateRoute>} />
          <Route path="/fields" element={<PrivateRoute><Fields /></PrivateRoute>} />
          <Route path="/auth/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/auth/registration" element={<PublicRoute><Registration /></PublicRoute>} />
          <Route path="/auth/logout" element={<Logout />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <RouteTitleUpdater/>
      </TimeModalProvider>
    </ModalProvider>
  );
}

export default App;
